export enum OutputColors {
  black = "#000",
  main = "#83c5be",
}
